import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateUnifiedLinkRpcContract = rpcContract({
  name: "updateUnifiedLink",
  paramsSchema: v.object({
    linkId: v.string(),
    // Basic link fields
    title: v.pipe(v.string(), v.minLength(1), v.maxLength(50)),
    url: v.pipe(v.string(), v.url(), v.maxLength(2000)),
    teaser: v.optional(v.pipe(v.string(), v.maxLength(150))),
    fileId: v.optional(v.union([v.string(), v.literal("")])), // Support file updates/removal

    // Discount-specific fields (optional, allows converting to/from discount)
    has_discount: v.optional(v.boolean(), false),
    brand_id: v.optional(v.nullable(v.string())),
    is_code_required: v.optional(v.boolean()),
    code: v.optional(v.string()),
    start_date: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    end_date: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    published_at: v.optional(v.pipe(v.string(), v.isoTimestamp())),

    // Premium content fields
    contentTier: v.optional(v.picklist(["free", "premium"])),
    oneTimePriceCents: v.optional(v.pipe(v.number(), v.minValue(100), v.maxValue(99999))),
    oneTimeProductId: v.optional(v.string()),
  }),
  resultSchema: v.object({
    linkId: v.string(),
  }),
});

export type UpdateUnifiedLinkParams = v.InferOutput<(typeof updateUnifiedLinkRpcContract)["paramsSchema"]>;
export type UpdateUnifiedLinkResult = v.InferOutput<(typeof updateUnifiedLinkRpcContract)["resultSchema"]>;
